module.exports = __webpack_public_path__ + "images/liinilaevad/routes/TAL-NAI-TAL-inactive@3x.png";